import HttpFactory from '@/mixins/http.factory';
import HtmlEditor from '@/components/Inputs/HtmlEditor'
export default {
	name:'issue-log',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			editorObj:null,
			linkedIssue:{attachments:[]},
			notifyData:{attachments:[],files:[]},
			IssueLog:{Issue:null,comments:null,show:false,showNoComments:false},
			zendeskInfo:{credentials:null,user:null,ticket:null,origin:null,app_guid:null,attachments:[],linkedItems:[]}
		}
	},
	created(){
		this.init();
	},
	components:{HtmlEditor},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			var triggerInstance=`issue-log-dialog_zd${this.$route.query.hdTicketId}_wd${this.$route.query.issueId}`
			modalClient.on(triggerInstance, (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo=data;
					_self.linkedIssue=data.linkData;
					_self.IssueLogFn(true);
					setTimeout(function(){_self.initDropzone(data);},500);
				}
			});
			setTimeout(function(){_self.fn().createHtmlEditor('editor');},1000);
		},
		IssueLogFn(isInit){
			let _self=this;
			let linkData=_self.linkedIssue;
			_self.notifyData.hdTicketId=linkData.hdTicketId;
			_self.notifyData.issueId=linkData.issueId;
			_self.notifyData.repository=linkData.repository;
			let data=linkData;
			data.auth=_self.zendeskInfo.credentials;
			data.repository=linkData.repository;
			var url = `zendesk/showLog/${linkData.hdTicketId}/${encodeURIComponent(linkData.issueId)}`;
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				let issueLog=response.data.Data;
				issueLog.showNoComments=false;
				if(!issueLog.comments || issueLog.comments.length<=0){
					issueLog.showNoComments=true;
				}
				_self.IssueLog=issueLog;
				
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		initDropzone(data){
			const _self=this;
			if(!data || !data.userInfo || !data.userInfo.uploadFiles)return;
			let params=JSON.parse(JSON.stringify(data.credentials));
			params.linkedRepos=[data.linkData.repository];
			_self.notifyData.files=[];
			_self.fn().initDropzone('div.dropzone',params,'github',function(error,response){
				if(error){
					return;
				}
				//_self.notifyData.files=_self.notifyData.files.concat(response);
				let filesJson={
					fileName: response[0].fileName,
					fileSize: response[0].fileSize,
					fileSizeUI: response[0].fileSizeUI,
					fileType:response[0].fileType,
					content_url:response[0].uploads[0].content_url,
					file_name:response[0].uploads[0].file_name,
					repo:response[0].uploads[0].repo
				};
				_self.notifyData.files.push(filesJson);
			});
		},
		removeFile(file){
			const _self=this;
			_self.notifyData.files=_self.notifyData.files.filter(d=>d.id!=file.id);
		},
		notifyIssueFn(){
			let _self=this;
			_self.fn().clearMessage();
			let data=_self.notifyData;
			if(_self.editorObj)
            	data.commentText=_self.fn().getHtmlEditorContent();
            
			if(!data.commentText || data.commentText.trim()==''){
				_self.userMsg={show:true,type:'danger',list:[`Please enter the comment description`]}
				return;
			}
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			data.hdTicketId=_self.zendeskInfo.ticket.id;
			
			let url=`zendesk/notifylinked/${data.hdTicketId}/${data.issueId}/${data.repository}`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(response.data.Success){
					_self.notifyData={attachments:[],files:[]};
					_self.IssueLogFn();
					let userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Issue: #${data.IssueId} notified Successfully`]}
					_self.userMsg=userMsg;
					_self.fn().clearHtmlEditorContent();
					//_self.sendDataToParent(response.data);
				}
				_self.data=response.data.Data;
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		htmlEditorChange(data){
			const _self=this;
			_self.notifyData.commentText=data.htmlContent?data.htmlContent:null;
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		}
	}
}

